;var timeline = (function (window, _, $) {
	var canvas = $("#timeline__curve");
	var ctx;
	var splinePoints;

	function showFollower() {
		if(BrowserDetect.browser == 'Chrome' || BrowserDetect.browser == 'Safari') {
			return true;
		} else {
			return false;
		}
	}

	if(canvas.length && showFollower()) {
		// Pin the canvas to top of the screen
		var controller = new ScrollMagic.Controller();
  		new ScrollMagic.Scene({triggerElement: ".timeline__main__graphic", triggerHook: 0, reverse: true})
				.setPin("#timeline__curve", {pushFollowers: false})
				.addTo(controller);
		
		init();

		function init() {
			if(canvas.get(0) && $(window).width() > canvas.width()) {
		  		// Set the height of the canvas
		  		canvas.attr('height', Math.round($(window).height())); 

		  		if(canvas.css('position') == 'fixed') { canvas.css('left', '50%')}

		  		ctx = canvas.get(0).getContext("2d");
		  		var points = getTimelinePoints([-100, -350, 300, 100]); // some startingpoints (x,y pairs) 

		  		// Calculate the curve points from the cardinal-spline-js package
		  		splinePoints = getCurvePoints(points, 0.5, 35); // returns a Float32Array
		  		splinePoints = Array.from(splinePoints);
				splinePoints.splice(0, 64); // Remove the first 64, because they will not be visible

				// Round all the values
				for(var i = 0; i < splinePoints.length; i++) {
					splinePoints[i] = Math.round(splinePoints[i]);
				}

				// Initialy on page load we draw the limeline, with no colored points
				drawTimeline(splinePoints, []);
			}
		}

	  	/*
	  	* For the height of the canvas we generate random X and Y points
	  	*/
	  	function getTimelinePoints(pointsArray) {
	  		var positionX = 'left';

	  		var extraLoopsIndex = 0;
	  		var extraLoops = 2;

	  		for(var y = getRndInteger(650, 900); y < $('.timeline__main').height() || extraLoopsIndex < extraLoops; y += getRndInteger(750, 1050)) {

	  			if(positionX == 'left') {
	  				x = getRndInteger(50, 200);
	  				positionX = 'right';
	  			} else {
	  				x = getRndInteger(400, 550);
	  				positionX = 'left';
	  			}
	  			pointsArray.push(x);
	  			pointsArray.push(y);

	  			if(y >= $('.timeline__main').height())  {
	  				extraLoopsIndex++;
	  			}
	  		}
	  		return pointsArray;
	  	}

	  	function getRndInteger(min, max) {
	  		return Math.random() * (max - min) + min;
	  	}

		/*
	  	* For all the points we draw a line between them with a default of
	  	* lineWidth of 10 and stroke color black. 
	  	*/
	  	function drawTimeline(points, colorPoints) {
	  		for(var i = 0; i < points.length; i+=2) {
	  			var lineWidth = 10;
	  			ctx.strokeStyle = "black";      

				// If there are points that need to be colored, we get them in the colorPoints array
				// if the points are points in a stroke we color them based on their index and we set the
				// appropiate lineWidth
				for(var j = 0; j < colorPoints.length; j+=2) {

					if(points[i] == colorPoints[j] && points[i+1] == colorPoints[j+1]) {
						if(j == 0) {
							lineWidth = 11;
							ctx.strokeStyle = '#004f6f';
						} else if (j == 2) {
							lineWidth = 13;
							ctx.strokeStyle = '#006f9c';
						} else if (j == 4) {
							lineWidth = 15;
							ctx.strokeStyle = '#007fb2';
						} else if (j == 6) {
							lineWidth = 18;
							ctx.strokeStyle = '#009fdf'; 
						}
					}
				}

				ctx.beginPath();
				
				// Since we want a 'dotted' line effect, we only draw the line for a small part
				// in this case it's the same as the lineWidth because the dots are square
				ctx.lineWidth = lineWidth;
				drawLineLength(points[i], points[i+1], points[i+2], points[i+3], lineWidth);
				
				// Draw the line!
				ctx.stroke();
			}
		}

		/*
		* Draw a line between two points with a max length
		*/
		function drawLineLength (x1, y1, x2, y2, maxLen) {
		    var vx = x2 - x1; // get dist between start and end of line
		    var vy = y2 - y1; // for x and y

		    // use pythagoras to get line total length
		    var mag = Math.sqrt(vx * vx + vy * vy); 
		    if (mag > maxLen) { // is the line longer than needed?

		        // calculate how much to scale the line to get the correct distance
		        mag = maxLen / mag;
		        vx *= mag;
		        vy *= mag; 
		    }
		    ctx.moveTo(x1, y1);
		    ctx.lineTo(x1 + vx, y1 + vy);
		}

		// Based on scroll position we want some black dots in the timeline to
		// get another color and width
		var lastScrollTop = 0;
		var scrollingDown = false;
		$(window).scroll(_.throttle(function(){
			// Determine if we are scrolling down or up
			var st = $(this).scrollTop();
			if (st > lastScrollTop){
				scrollingDown = true;
			} else {
				scrollingDown = false;
			}
			lastScrollTop = st;

			// Determine the Y point on the screen where the blue dots should be visible (centerY)
			// We create a temp clone of our splinePoints array and we loop through it
			// We check if the index is uneven (= Y coordinate) and then subtract the window.scrollTop
			// Since the timeline is redrawn every scroll it creates the illusion that we are scrolling
			var tempSplinePoints = splinePoints.slice(0); //clone
			var x = 0;
			var y = 0;
			var canvasContainerTop = $('.timeline__main__graphic').offset().top;
			var windowScrollTop = $(window).scrollTop();
			var canvasRelativeTop = (canvasContainerTop - windowScrollTop) >= 0 ? (canvasContainerTop - windowScrollTop) : 0;
			var indexY = 0;
			var centerY = ($(window).height() / 1.5) - canvasRelativeTop;
			for(var i = 1; i < tempSplinePoints.length; i+=2) {
				if(i % 2 === 1) {
					if(windowScrollTop > canvasContainerTop) {
						tempSplinePoints[i] = tempSplinePoints[i] - windowScrollTop + canvasContainerTop;
					}
					
					// Get the x and y coordinates of our main point to be colored based on the centerY
					if(tempSplinePoints[i] >= centerY && y == 0) {
						x = tempSplinePoints[i - 1];
						y = tempSplinePoints[i];
						indexY = i;
					}
				}
			}

			// We want to get the coordinates of the previous 3 points too, and we store all in an array
			var points = [],		
			point1_x = tempSplinePoints[indexY - 7],
			point1_y = tempSplinePoints[indexY - 6],
			point2_x = tempSplinePoints[indexY - 5],
			point2_y = tempSplinePoints[indexY - 4],
			point3_x = tempSplinePoints[indexY - 3],
			point3_y = tempSplinePoints[indexY - 2];
			
			// The order of the array will depend on if we are scrolling down or up
			if(scrollingDown) {
				points = [point1_x, point1_y, point2_x, point2_y, point3_x, point3_y, x, y];
			} else {
				points = [x, y, point3_x, point3_y, point2_x, point2_y, point1_x, point1_y];
			}

			// Every time we scroll we clear the canvas
			ctx.clearRect(0, 0, canvas.width(), canvas.height());

			// Draw the timeline with some colored dots!
			drawTimeline(tempSplinePoints, points);
		}, 4));
		
		// Recalculate everything on screen resize
		$(window).resize(function() {
			if(this.resizeTO) {
				clearTimeout(this.resizeTO);
			}

			this.resizeTO = setTimeout(function() {
				$(this).trigger('resizeEnd');
			}, 500);
		});

		$(window).bind('resizeEnd', function() {
			init();
		});

		$(window).bind('timelineLoaded', function() {
			init();
		});
	}

})(window, _, jQuery);